import { isDefinedString } from "et3-type-guards";
import DatePicker from "react-datepicker";

import { TEt3DatePicker } from "../../../TypesNEW";
import { getSpecificDateWithDays } from "../../et3-date";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import { getDayMonthYearJsFormat } from "../../../helpers/et3-date-helper";

const tomorrow = getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 });
const futureDate = getSpecificDateWithDays({
  daysSubtracted: 0,
  daysAdded: 1000
});
const oldDate = getSpecificDateWithDays({
  daysSubtracted: 1000,
  daysAdded: 0
});
const yesterday = getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 0 });

const Et3Date = withLiteObserverAndTheme<TEt3DatePicker>((props) => {
  const {
    label,

    hasMax,
    hasMin,
    theme,
    dateInputObservable,
    isEnabled
  } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      withShadow={false}
      width={280}
      height={75}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {isDefinedString(label) ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={300}
          height={30}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              height: 18 * unitY,
              paddingTop: 0
            }}
          />
        </ET3Div>
      ) : null}

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={true}
        width={280}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{
          borderRadius: 39 * unitX
        }}
        onClick={() => {}}
      >
        <DatePicker
          maxDate={hasMax ? tomorrow : futureDate}
          minDate={hasMin ? yesterday : oldDate}
          className="date-picker"
          placeholderText={label}
          dateFormat="dd/MM/yyyy"
          onChange={(date) => {
            const formatedJsDate = getDayMonthYearJsFormat(date);
            return dateInputObservable.set(formatedJsDate);
          }}
          selected={dateInputObservable.get()}
          disabled={!isEnabled}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Et3Date;
